var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "custom-fields" },
    [
      _vm.loadingData
        ? _c("SpinnerLayerComponent", { staticClass: "spinner-layer" })
        : [
            _vm.formSchema.length > 0 && _vm.fieldValues
              ? _c("FormGeneratorComponent", {
                  attrs: {
                    schema: _vm.formSchema,
                    fieldValues: _vm.fieldValues,
                    context: _vm.context,
                    validateOnLoad: "",
                    permissionsEntity: _vm.permissionsEntity,
                  },
                  on: { saveFormData: _vm.onChangeFormFieldValue },
                })
              : _c("CustomFieldsEmptyMessageComponent"),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }